import { Mail, Mailbox, SendHorizonal } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../../lib';
import { Badge, Tooltip, TooltipContent, TooltipTrigger } from '../../ui';

type NotificationTypeBadgeProps = Readonly<{
  type: keyof typeof typeStyles;
}>;

const typeStyles = {
  EMAIL: {
    icon: Mail,
    className: 'hover:bg-slate-200',
  },
  LRE: {
    icon: Mailbox,
    className: 'hover:bg-slate-200',
  },
  ERE: {
    icon: SendHorizonal,
    className: 'hover:bg-slate-200',
  },
};

export function NotificationTypeBadge({ type }: NotificationTypeBadgeProps) {
  const { t } = useTranslation();
  const TypeIcon = typeStyles[type].icon;

  return (
    <Tooltip>
      <TooltipTrigger>
        <Badge
          variant="outline"
          className={cn('flex items-center gap-1', typeStyles[type].className)}
        >
          <TypeIcon size={14} />
          {t(`notifications.types.badge.${type}`)}
        </Badge>
      </TooltipTrigger>
      <TooltipContent>{t(`notifications.types.tooltip.${type}`)}</TooltipContent>
    </Tooltip>
  );
}
